import { atom } from "recoil";
import { ILeasedEquipmentDetails, SelectedRows } from "../type";

export const leShowState = atom({
  key: "leShowState",
  default: false,
});

export const ledAddState = atom({
  key: "ledAddState",
  default: false,
});

export const ledEditState = atom({
  key: "ledEditState",
  default: false,
});

export const rowForEditLE = atom<ILeasedEquipmentDetails | undefined>({
  key: "rowForEditLE",
  default: undefined,
});

export const rowForEditLeasedEquipment = atom<
  ILeasedEquipmentDetails | undefined
>({
  key: "rowForEditLeasedEquipment",
  default: undefined,
});

export const leasedEquipmentSaving = atom({
  key: "leasedEquipmentSaving",
  default: false,
});

export const setLinkStateLeasedEquipment = atom({
  key: "setLinkStateLeasedEquipment",
  default: false,
});

export const selectedRowsLE = atom<SelectedRows | undefined>({
  key: "selectedRowsLE",
  default: undefined,
});

export const selectedRowsStateLe = atom({
  key: "selectedRowsStateLe",
  default: [],
});

export const leFromOffice = atom({
  key: "leFromOffice",
  default: false,
});

export const leAttachments = atom<(File | null)[]>({
  key: "leAttachments",
  default: [null],
});

export const leAttachmentsForDelete = atom({
  key: "leAttachmentsForDelete",
  default: [],
});

export const lEViewData = atom({
  key: "lEViewData",
  default: false,
});

export const leasedEquipmentOfficeId = atom({
  key: "leasedEquipmentOfficeId",
  default: undefined,
});

export const leasedEquipmentFromOffice = atom({
  key: "leasedEquipmentFromOffice",
  default: false,
});

export const disableLEOfficeField = atom({
  key: "disableLEOfficeField",
  default: false,
});

export const lEtoVendor = atom({
  key: "lEtoVendor",
  default: [],
});

export const vendorLeasedId = atom({
  key: "vendorLeasedId",
  default: undefined,
});

export const disableLEVendorField = atom({
  key: "disableLEVendorField",
  default: false,
});

export const leFromVendor = atom({
  key: "leFromVendor",
  default: false,
});

// mass upload

export const leAllMassUploadData = atom({
  key: "leAllMassUploadData",
  default: [],
});

export const leEditMassUpload = atom({
  key: "leEditMassUpload",
  default: false,
});

export const leMassUploadData = atom({
  key: "leMassUploadData",
  default: [],
});

const defaultRowData = {
  type: "",
  make: "",
  model: "",
  officeName: undefined,
  officeCode: undefined,
  officeNumber: undefined,
  address: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  districtManager: "",
  districtManagerEmail: "",
  serialNumber: "",
  customerNumber: "",
  vendorLocationNumber: "",
  status: "",
  servicingDealer: "",
};

export const leRowData = atom({
  key: "leRowData",
  default: defaultRowData,
});
// export const leasedEquipmentForEdit = atom<ILeasedEquipmentDetails | undefined>(
//   {
//     key: "leastEquipmentForEdit",
//     default: undefined,
//   }
// );
// export const leasedEquipmentForEdit = atom({
//   key: "leastEquipmentForEdit",
//   default: [],
// });

export const leasedEquipmentForEdit = atom<ILeasedEquipmentDetails | undefined>(
  {
    key: "leastEquipmentForEdit",
    default: undefined,
  }
);

// import {
//   agmtAllMassUploadData,/
//   agmtEditMassUpload,
//   agmtMassUploadData,/
//   agmtRowData,/
//   agreementForEdit,
// } from "../atoms/atoms";

// import {
//   leAllMassUploadData,
//   leEditMassUpload,
//   leMassUploadData,
//   leRowData,
//   leastEquipmentForEdit,
